module.exports = __webpack_public_path__ + "img/V-63-ER-1200-N.8a28723b.png";